module.exports = __webpack_public_path__ + "static/media/bb.9873885f.svg";